import { useEffect, useRef, useState } from "react"
import { customToast } from "../../components/Toast"
import { useChatContext } from "../../core/context/chatContext"
import { AssistanceLinkMessageScreen } from "../../screen/AssistanceLinkMessageScreen"
import { useAssistancePlanContext } from "../../core/context/assistancePlanContext"
import { blobToBase64, processFile, sendFileToFirebase } from "../../core/utils/hooks/uploadItem"

export const AssistanceLinkMessageContainer = ({
  formQuestionMessage,
  setFormQuestionMessage,
  handleCloseTab,
  pinnedMessages,
}) => {
  const hasInitialized = useRef(false);
  const { removePinnedMessage, pinnedMessagesQuestions, evidenceId } = useChatContext()
  const { handleChangeEvidence, answers, handleRemoveEvidence } = useAssistancePlanContext()
  const [loadingProcessImage, setLoadingProcessImage] = useState(false)
  const [uploadedEvidences, setUploadedEvidences] = useState([])

  const safeUploadedEvidences = Array.isArray(uploadedEvidences) ? uploadedEvidences : [];
  const safeFormQuestionEvidences = Array.isArray(formQuestionMessage?.evidencesLinks) ? formQuestionMessage?.evidencesLinks : [];
  const evidences = Array.from(new Set([...safeFormQuestionEvidences, ...safeUploadedEvidences].map(item => item.url)))
    .map(url => safeFormQuestionEvidences.find(item => item.url === url) || safeUploadedEvidences.find(item => item.url === url)) || []

  useEffect(() => {
    if (!hasInitialized.current && answers) {
      hasInitialized.current = true;
      setFormQuestionMessage(prev => ({
        ...prev,
        evidencesLinks: answers[`${formQuestionMessage?.name}-evidence`]?.filter(row => row)
      }));
    }
  }, [answers]);

  const handleUploadEvidence = async (files, questionId, resetInput) => {
    try {
      setLoadingProcessImage(questionId)

      const processedFiles = await Promise.all(files.map((file) => processFile(file, true)));
      const processedFilesWithoutURL = processedFiles?.map(item => item.url) || []

      const existingFiles = formQuestionMessage?.evidencesLinks?.map(item => item) || []

      const uniqueFiles = [...new Set(processedFilesWithoutURL), ...existingFiles.map(row => row?.url)]

      let newUploadedEvidences = [...(Array.isArray(uploadedEvidences) ? uploadedEvidences : []), ...processedFiles, ...existingFiles];

      newUploadedEvidences = uniqueFiles.map(file => {
        const existingFile = newUploadedEvidences.find(item => item.url === file)

        if (existingFile) {
          return existingFile
        }

        return null
      }).filter(Boolean)

      setUploadedEvidences(newUploadedEvidences);

      handleChangeEvidence(questionId, newUploadedEvidences)

      customToast("Upload concluido com sucesso", "success")
    } catch (error) {
      customToast("Erro ao fazer upload dos arquivos", "error")
      console.log(error)
    } finally {
      setLoadingProcessImage("")
      resetInput?.();
    }
  }

  const onChangeFile = async (e, questionId, existingFiles = []) => {
    const chosenFiles = Array.from(e.target.files)

    if (e.target?.remove) {
      //handleChangeEvidence(questionId, answers[`${questionId}-messages`] || [])
      return
    }

    await handleUploadEvidence(chosenFiles, questionId, () => {
      e.target.value = null;
    })
  }

  const handleUploadPhotos = async (images) => {
    await handleUploadEvidence(images, evidenceId)
  }

  return (
    <AssistanceLinkMessageScreen
      formQuestionMessage={formQuestionMessage}
      answers={answers}
      uploadedEvidences={uploadedEvidences}
      handleCloseTab={handleCloseTab}
      handleUploadPhotos={handleUploadPhotos}
      removePinnedMessage={removePinnedMessage}
      onChangeFile={onChangeFile}
      loadingProcessImage={loadingProcessImage}
      pinnedMessages={pinnedMessages}
      pinnedMessagesQuestions={pinnedMessagesQuestions}
      handleRemoveEvidence={handleRemoveEvidence}
      questionId={evidenceId}
      evidences={evidences}
    />
  )
}
